import * as React from 'react';
import { PVAPage } from './layout/PVAPage';
import { BaseAuthService } from '../services/api/BaseAuthService';
import { BACKEND_ROOT } from '../config/host-config';

interface Message {
    role: string;
    content: string;
}

interface AssistantState {
    command: string;
    response: string;
    loading: boolean;
    history: Message[];
}

export class Assistant extends React.Component<{}, AssistantState> {
    private apiService: BaseAuthService;
    private commandInput: HTMLInputElement | null = null;

    constructor(props: {}) {
        super(props);
        this.state = {
            command: '',
            response: '',
            loading: false,
            history: []
        };
        this.apiService = new BaseAuthService();
    }

    private handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const { command, history } = this.state;
        if (!command.trim()) return;

        this.setState({ loading: true, response: '' });

        try {
            const endpoint = `${BACKEND_ROOT}/api/adminassistant/execute`;
            const init = (this.apiService as any).buildRequestInit('POST', {
                command,
                history
            });

            const response = await fetch(endpoint, init);
            if (response.ok) {
                const data = await response.json();
                let displayResponse = '';
                if (typeof data === 'string') {
                    displayResponse = data;
                } else if (data && typeof data.result === 'string') {
                    displayResponse = data.result;
                } else {
                    displayResponse = JSON.stringify(data, null, 2);
                }
                this.setState({ 
                    response: displayResponse, 
                    command: '',
                    history: [...history, { role: 'user', content: command }, { role: 'assistant', content: displayResponse }]
                });
            } else {
                const errorText = await response.text();
                this.setState({ response: errorText || `Error: ${response.statusText}`, command: '' });
            }
        } catch (error) {
            this.setState({ response: `Error: ${error.message}`, command: '' });
        } finally {
            this.setState({ loading: false }, () => {
                if (this.commandInput) {
                    this.commandInput.focus();
                }
            });
        }
    }

    public render() {
        const { response } = this.state;

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            <span className="greyDark">🤖 Assistant</span>
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                </PVAPage.Header>
                <PVAPage.Body>
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="commandInput">Enter command:</label>
                                    <div className="input-group">
                                        <input
                                            id="commandInput"
                                            ref={(input) => { this.commandInput = input; }}
                                            type="text"
                                            className="form-control"
                                            value={this.state.command}
                                            onChange={(e) => this.setState({ command: e.target.value })}
                                            placeholder="Ask something..."
                                            disabled={this.state.loading}
                                        />
                                        <span className="input-group-btn">
                                            <button 
                                                className="btn btn-primary" 
                                                type="submit"
                                                disabled={this.state.loading || !this.state.command.trim()}
                                            >
                                                {this.state.loading ? 'Submitting...' : 'Submit'}
                                            </button>
                                            <button 
                                                className="btn btn-default" 
                                                type="button"
                                                onClick={() => this.setState({ history: [], response: '', command: '' })}
                                                disabled={this.state.loading}
                                                style={{ marginLeft: '5px' }}
                                            >
                                                New Conversation
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </form>
                            <div className="form-group" style={{ marginTop: '20px' }}>
                                <label>Response:</label>
                                <textarea
                                    className="form-control"
                                    rows={15}
                                    value={response}
                                    readOnly={true}
                                    style={{ backgroundColor: '#f9f9f9', cursor: 'default' }}
                                />
                            </div>
                        </div>
                    </div>
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Assistant.tsx